<div class="animate__animated animate__fadeInRight container-fluid">
  <!-- Fila 1 de los números de los contratos -->
  <div class="row">
      <!-- MESANJES INFORMATIVOS -->
      <div class="col-12 pb-0 pt-0">
          <p-messages [(value)]="message" [enableService]="false"></p-messages>
      </div>
      <div class="col col-3">
          <mat-card>
              <mat-card-title class="cards1">
                  <span style="text-align: center;">Contratos a plazo</span>
              </mat-card-title>

              <mat-card-content>
                  <h1 style="text-align: center;">{{totalPlazoFijo??0}}</h1>
              </mat-card-content>
          </mat-card>
      </div>
      <div class="col col-3">
          <mat-card>
              <mat-card-title class="cards1">
                  <span >Contratos Indefinidos</span>
              </mat-card-title>

              <mat-card-content>
                  <h1 style="text-align: center;">{{totalPlazoIndefinido??0}}</h1>
              </mat-card-content>
          </mat-card>
      </div>
      <!-- <div class="col col-3">
          <mat-card>
              <mat-card-title >
                  <span>Contratos por Obra o Faena</span>
              </mat-card-title>

              <mat-card-content>
                  <h1 style="text-align: center;">{{totalObraFaena??0}}</h1>
              </mat-card-content>
          </mat-card>
      </div> -->
      <div class="col col-3">
        <mat-card>
            <mat-card-title >
                <span>Ingreso de colaboradores ({{ monthNames[currentMonth] }})</span>
            </mat-card-title>

            <mat-card-content>
                <h1 style="text-align: center;">{{totalIngresosMes??0}}</h1>
            </mat-card-content>
        </mat-card>
    </div>
      <div class="col col-3">
          <mat-card>
              <mat-card-title>
                  <span>Finiquitados</span>
              </mat-card-title>

              <mat-card-content>
                  <h1 style="text-align: center;">{{totalFiniquitado??0}}</h1>
              </mat-card-content>
          </mat-card>
      </div>
      <div class="col-12">
          <p-tabView [(activeIndex)]="index" (onChange)="handleChange($event)">
              <p-tabPanel>
                  <ng-template pTemplate="header">
                      <i class="pi pi-dollar mr-2"></i><p style="font-family: 'Poppins', sans-serif;" class="mb-0">Indicadores previsionales</p>
                  </ng-template>
                  <app-indicadores-previsionales class="fadeInOut"></app-indicadores-previsionales>
          </p-tabPanel>

              <p-tabPanel>
                  <ng-template pTemplate="header">
                      <i class="pi pi-file mr-2"></i><p style="font-family: 'Poppins', sans-serif;" class="mb-0">Contratos a plazo fijo por vencer ( {{ countContratoVencer }} )</p>
                  </ng-template>
                  <div id="contratosPorVencer">
                      <app-contratos-por-vencer class="fadeInOut" [cargarTabla]="cargarTablaContratos"
                          (countContratoVencer)="recibirCountContrato($event)"></app-contratos-por-vencer>
                  </div>
          </p-tabPanel>
          <p-tabPanel>
              <ng-template pTemplate="header">
                  <i class="pi pi-file mr-2"></i><p style="font-family: 'Poppins', sans-serif;" class="mb-0"> Anexos de contrato por vencer ( {{ countAnexosVencer }} )</p>
              </ng-template>
              <div id="contratosAnexoPorVencer">
              <app-contratos-anexos-por-vencer [cargarTabla]="cargarTablaAnexos"
              (countAnexosVencer)="recibirCountAnexo($event)"></app-contratos-anexos-por-vencer>
          </div>
      </p-tabPanel>

                  <p-tabPanel>
                      <ng-template pTemplate="header">
                          <i class="pi pi-star mr-2"></i><p style="font-family: 'Poppins', sans-serif;" class="mb-0"> Fechas de cumpleaños</p>
                      </ng-template>
                      <app-fechas-cumpleanios class="fadeInOut"></app-fechas-cumpleanios>

              </p-tabPanel>
          </p-tabView>
      </div>
  </div>
</div>
